module.exports = {"name":"Couch Park","description":"Couch Park also known as the Burger Bowl, is a multi-purpose greenspace on the west side of Georgia Tech's campus. ","parking":"Parking on Georgia Tech's campus is not easy if you do not have a parking pass. There is a paid parking lot on the corner of Ferst Dr and State St.","location":"https://www.google.com/maps/place/Couch+Park+(Burger+Bowl+Field),+Atlanta,+GA+30318/@33.7784434,-84.4037518,17.63z"}


//////////////////
// WEBPACK FOOTER
// ./src/data/couch-park.json
// module id = ./src/data/couch-park.json
// module chunks = main